import { DateObject } from '@packages/shared/core/common/entities/Date';
import { generateDates } from '../utils/generateDates';

export const DEFAULT_BIRTH_DATE_OBJECT: DateObject = {
  month: 'Jan',
  day: '01',
  year: '1990',
};
export const DEFAULT_BIRTH_DATE = '1990-01-01';

export const shortMonthsList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const monthsList = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const greatestBirthYear = new Date().getFullYear() - 18;

export const yearsList = generateDates(1940, greatestBirthYear, 'decrement');

export const yearsListReverse = [...yearsList].sort((a, b) => Number(a) - Number(b));
